import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { usePlatform } from 'context/PlatformContext';
import { useAuth } from 'Auth';
import SampleQuestionsController from './SampleQuestionsController';
import SampleStationsController from './SampleStationsController';
import SampleMockTestsController from './SampleMockTestsController';

type TryOutExerciseType = 'questions' | 'stations' | 'mock-tests';

type SampleParams = {
  exerciseType: TryOutExerciseType;
  exerciseId: string;
  productType: string;
};

const getSampleExercise = (exerciseType?: TryOutExerciseType) => {
  switch (exerciseType) {
    case 'questions':
    default:
      return SampleQuestionsController;
    case 'stations':
      return SampleStationsController;
    case 'mock-tests':
      return SampleMockTestsController;
  }
};

const Sample = () => {
  const { exerciseType, productType = '1' } = useParams<SampleParams>();
  const { setProduct, setApp } = usePlatform();
  const { setIsDemo } = useAuth();

  useEffect(() => {
    setProduct(null);
    setIsDemo(false);
    setApp(null);
  }, [setApp, setIsDemo, setProduct, productType]);

  const ExerciseController = getSampleExercise(exerciseType);

  return (
    <ExerciseController productType={Number(productType)}>
      <Outlet />
    </ExerciseController>
  );
};

export default Sample;
